bq.global.slickSetup = function() {

    $('[data-slick]').not(':hidden').each(function(){
      var $this = $(this);
      if ($this[0].slick) {
        $this[0].slick.setPosition();
        return true;
      }


      $this.slick();

      if ($this.is('.without_listbox')) {
        $this.find('.slick-slide').removeAttr('role');
      } else {
        $this.find('.slick-track')
            .attr('role', 'listbox')
            .attr('aria-label', bq.messages.global.slider);
      }

      if ($this[0].slick) {

        //Display slider items only once the slider's position has been
        $this.on('setPosition', function () {

          //For displaying general lists of divs within a slider only after position of the slider has been calculated
          //Slider html definition not should contain class 'slick-slider' that child items on load
          $(this).children().css('display', 'block');

          /**
           * For columns within a slider. Columns should have 'hidden' class in order to prevent display before
           * position calculation.
           */
          $(this).find('.slick-list .slick-track > div').removeClass('hidden');

        });

        $this[0].slick.setPosition();

        setTimeout(function(){
          $this[0].slick.setPosition();
        }, 500);
      } else {
        $this.slick($this.data('slick'));
        $this.slick.setPosition();

        setTimeout(function(){
          $this.slick.setPosition();
        }, 500);
      }

      $this.on('afterChange', function(){
        $this.find('.slick-active [data-bq="image-load"]:not(.lazy-loaded)').lazyLoadXT({show: true});
      });
    });

  
};

$(document).bind('shown.bs.tab', bq.global.slickSetup);

$(document).ready(function() {
  if ($('.slick-track').length > 1) {
	  $('.slick-track').each(function(i){
	    var arrows = $(this).closest('.thumbnail-container').find('.slick-arrow');

		  arrows.each(function(){
		    var oldId = $(this).attr('id');

			  $(this).attr('id', oldId + '-' + i);
      });
    });
  }
});

bq.init.push(bq.global.slickSetup);
